export default __webpack_public_path__ + "static/media/newImg5.04a71470.svg";